export const all_routes = {

  home: "/index",
  signup: "/authentication/register",
  login: "/authentication/login",
  forgotpassword: "/authentication/forgot-password",
  resetpassword: "/authentication/reset-password",
  services: "/pages/services",
  serviceDetail: "/pages/service-detail",
  aboutus: "/pages/aboutus",
  listinggrid: "/listings/vehicle",
  listinglist: "/listings/vehicle-list",
  listingdetails: "/listings/vehicle-details",
  contactowner: "/authentication/contact-owner",
  pricing: "/pages/pricing",
  faq: "/pages/faq",
  gallery: "/pages/gallery",
  bloglist: "/blog/blog-list",
  bloggrid: "/blog/blog-grid",
  blogdetails: "/blog/blog-details",
  bookingcheckout: "/pages/booking-payment",
  booking: "/pages/booking",
  invoice: "/pages/invoice-details",
  ourteam: "/pages/our-team",
  testimonial: "/pages/testimonial",
  termsconditions: "/pages/terms-condition",
  privacypolicy: "/pages/privacy-policy",
  maintenance: "/pages/maintenance",
  comingsoon: "/pages/coming-soon",
  error404: "/pages/error-404",
  error500: "/pages/error-500",
  contact: "/contact",
  dashboard: "/user/user-dashboard",
  userbookings: "/user/user-bookings",
  reviews: "/user/user-reviews",
  wishlist: "/user/user-wishlist",
  messages: "/user/user-messages",
  userBookingComplete: "/user/user-booking-complete",
  userBookingCancelled: "/user/user-booking-cancelled",
  userBookingInprogress: "/user/user-booking-inprogress",
  userBookings: "/user/user-bookings",

  payment: "/user/user-payment",
  settings: "/user/user-settings",
  security: "/user/user-security",
  preference: "/user/user-preferences",
  notification: "/user/user-notifications",
  userintegration: "/user/user-integration",
  integration: "/user/user-integration",
  wallet: "/user/user-wallet",
  bookingcancelled: "/user/user-booking-cancelled",
  userBookingUpcoming: "/user/user-booking-upcoming",
};
